"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RpcErrorCode = exports.JsonRpcSource = exports.JsonRpcMethod = void 0;
var JsonRpcMethod;
(function (JsonRpcMethod) {
    JsonRpcMethod["face_logInSignUp"] = "face_logInSignUp";
    JsonRpcMethod["face_loggedIn"] = "face_loggedIn";
    JsonRpcMethod["face_logOut"] = "face_logOut";
    JsonRpcMethod["face_currentUser"] = "face_currentUser";
    JsonRpcMethod["face_accounts"] = "face_accounts";
    JsonRpcMethod["face_openIframe"] = "face_openIframe";
    JsonRpcMethod["face_closeIframe"] = "face_closeIframe";
    JsonRpcMethod["face_ready"] = "face_ready";
    JsonRpcMethod["face_openHome"] = "face_openHome";
    JsonRpcMethod["face_openWalletConnect"] = "face_openWalletConnect";
    JsonRpcMethod["face_confirmWalletConnectDapp"] = "face_confirmWalletConnectDapp";
    JsonRpcMethod["face_switchNetwork"] = "face_switchNetwork";
    JsonRpcMethod["face_directSocialLogin"] = "face_directSocialLogin";
    JsonRpcMethod["face_getIdToken"] = "face_getIdToken";
    JsonRpcMethod["face_loginWithIdToken"] = "face_loginWithIdToken";
    JsonRpcMethod["bora_connect"] = "bora_connect";
    JsonRpcMethod["bora_isConnected"] = "bora_isConnected";
    JsonRpcMethod["eth_sendTransaction"] = "eth_sendTransaction";
    JsonRpcMethod["eth_getBalance"] = "eth_getBalance";
    JsonRpcMethod["eth_call"] = "eth_call";
    JsonRpcMethod["eth_estimateGas"] = "eth_estimateGas";
    JsonRpcMethod["eth_sign"] = "eth_sign";
    JsonRpcMethod["eth_accounts"] = "eth_accounts";
    JsonRpcMethod["personal_sign"] = "personal_sign";
    JsonRpcMethod["personal_listAccounts"] = "personal_listAccounts";
    JsonRpcMethod["wallet_switchEthereumChain"] = "wallet_switchEthereumChain";
    JsonRpcMethod["solana_sendTransaction"] = "solana_sendTransaction";
    JsonRpcMethod["near_broadcast_tx_async"] = "near_broadcast_tx_async";
    JsonRpcMethod["near_get_balance"] = "near_get_balance";
    JsonRpcMethod["aptos_signMultiAgentTransaction"] = "aptos_signMultiAgentTransaction";
})(JsonRpcMethod = exports.JsonRpcMethod || (exports.JsonRpcMethod = {}));
var JsonRpcSource;
(function (JsonRpcSource) {
    JsonRpcSource["FACE_SDK"] = "FACE_SDK";
    JsonRpcSource["FACE_IFRAME"] = "FACE_IFRAME";
    JsonRpcSource["FACE_WALLET_CONNECT"] = "FACE_WALLET_CONNECT";
    JsonRpcSource["FACE_NATIVE_SDK"] = "FACE_NATIVE_SDK";
})(JsonRpcSource = exports.JsonRpcSource || (exports.JsonRpcSource = {}));
var RpcErrorCode;
(function (RpcErrorCode) {
    // Standard JSON RPC 2.0 Error Codes
    RpcErrorCode[RpcErrorCode["PARSE_ERROR"] = -32700] = "PARSE_ERROR";
    RpcErrorCode[RpcErrorCode["INVALID_REQUEST"] = -32600] = "INVALID_REQUEST";
    RpcErrorCode[RpcErrorCode["METHOD_NOT_FOUND"] = -32601] = "METHOD_NOT_FOUND";
    RpcErrorCode[RpcErrorCode["INVALID_PARAMS"] = -32602] = "INVALID_PARAMS";
    RpcErrorCode[RpcErrorCode["INTERNAL_ERROR"] = -32603] = "INTERNAL_ERROR";
})(RpcErrorCode = exports.RpcErrorCode || (exports.RpcErrorCode = {}));
//# sourceMappingURL=json-rpc.js.map